<template>
  <div>
    <div id="up">
      <h1 class="valor"></h1>
    </div>
    <div class="container-fluid">
      <div id="accordion1">
        <div id="Valor_img" class="collapse" data-bs-parent="#accordion1" data-bs-toggle="collapse" data-bs-target="#Valor_img">
          <img class="cityImage centerImage2 cursor" :src="require('../assets/Valor.png')" />
        </div>
        <div id="Falkhorn_img1" class="collapse" data-bs-parent="#accordion1" data-bs-toggle="collapse" data-bs-target="#Falkhorn_img1">
          <img class="cityImage centerImage2 cursor" :src="require('../assets/Falkhorn.png')" />
        </div>
      </div>
      <div class="container center">
        
          <button class="genericButton cursor inline" id="Valor"  data-bs-parent="#accordion1" data-bs-toggle="collapse" data-bs-target="#Valor_img">
            <h2 class="py-0">
              Map
            </h2>
          </button>
      </div>
      <div id="main-setting-container" class="container">
        <h3 class="fill-red">
          Southern Region <span class="miniText inline">Volcanoes, Mountains</span>
        </h3>
        <div id="accordion2">
          <div id="Thornbeak_img" class="collapse" data-bs-parent="#accordion2" >
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Thornbeak_img" :src="require('../assets/Thornbeak.png')" />
          </div>
          <div id="Firedeep_img" class="collapse" data-bs-parent="#accordion2">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Firedeep_img" :src="require('../assets/Firedeep.png')" />
          </div>
          <div id="Hillfar_img" class="collapse" data-bs-parent="#accordion2">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Hillfar_img" :src="require('../assets/Hillfar.png')" />
          </div>
          <div id="SouthernChannels_img" class="collapse" data-bs-parent="#accordion2">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#SouthernChannels_img" :src="require('../assets/SouthernChannels.png')" />
          </div>
          <div id="MapleFalls_img" class="collapse" data-bs-parent="#accordion2">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#MapleFalls_img" :src="require('../assets/MapleFalls.png')" />
          </div>
          <div id="Mossgrove_img" class="collapse" data-bs-parent="#accordion2">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Mossgrove_img" :src="require('../assets/Mossgrove.png')" />
          </div>
        </div>
        <div class="setting-grid-container">
          <div class="button cursor red" id="Thornbeak"         data-bs-parent="#accordion2" data-bs-toggle="collapse" data-bs-target="#Thornbeak_img">Thornbeak</div>
          <div class="button cursor red" id="Firedeep"          data-bs-parent="#accordion2" data-bs-toggle="collapse" data-bs-target="#Firedeep_img">Firedeep</div>
          <div class="button cursor red" id="Hillfar"           data-bs-parent="#accordion2" data-bs-toggle="collapse" data-bs-target="#Hillfar_img">Hillfar</div>
          <div class="button cursor red" id="SouthernChannels"  data-bs-parent="#accordion2" data-bs-toggle="collapse" data-bs-target="#SouthernChannels_img">Southern Channels</div>
          <div class="button cursor red" id="MapleFalls"        data-bs-parent="#accordion2" data-bs-toggle="collapse" data-bs-target="#MapleFalls_img">Maple Falls</div>
          <div class="button cursor red" id="Mossgrove"         data-bs-parent="#accordion2" data-bs-toggle="collapse" data-bs-target="#Mossgrove_img">Mossgrove</div>
        </div>
        <h3 class="fill-yellow">
          Western Region <span class="miniText inline">Savannah, Desert</span>
        </h3>
        <div id="accordion3">
          <div id="Windfell_img" class="collapse" data-bs-parent="#accordion3">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Windfell_img" :src="require('../assets/Windfell.png')" />
          </div>
          <div id="Frostport_img" class="collapse" data-bs-parent="#accordion3">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Frostport_img" :src="require('../assets/Frostport.png')" />
          </div>
          <div id="Copperbrook_img" class="collapse" data-bs-parent="#accordion3">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Copperbrook_img" :src="require('../assets/Copperbrook.png')" />
          </div>
          <div id="CloverSprings_img" class="collapse" data-bs-parent="#accordion3">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#CloverSprings_img" :src="require('../assets/CloverSprings.png')" />
          </div>
          <div id="Harbordock_img" class="collapse" data-bs-parent="#accordion3">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Harbordock_img" :src="require('../assets/Harbordock.png')" />
          </div>
          <div id="WesternGateway_img" class="collapse" data-bs-parent="#accordion3">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#WesternGateway_img" :src="require('../assets/WesternGateway.png')" />
          </div>
        </div>
        <div class="setting-grid-container">
          <div class="button cursor yellow" id="Windfell"       data-bs-parent="#accordion3" data-bs-toggle="collapse" data-bs-target="#Windfell_img">Windfell</div>
          <div class="button cursor yellow" id="Frostport"      data-bs-parent="#accordion3" data-bs-toggle="collapse" data-bs-target="#Frostport_img">Frostport</div>
          <div class="button cursor yellow" id="Copperbrook"    data-bs-parent="#accordion3" data-bs-toggle="collapse" data-bs-target="#Copperbrook_img">Copperbrook</div>
          <div class="button cursor yellow" id="CloverSprings"  data-bs-parent="#accordion3" data-bs-toggle="collapse" data-bs-target="#CloverSprings_img">Clover Springs</div>
          <div class="button cursor yellow" id="Harbordock"     data-bs-parent="#accordion3" data-bs-toggle="collapse" data-bs-target="#Harbordock_img">Harbordock</div>
          <div class="button cursor yellow" id="WesternGateway" data-bs-parent="#accordion3" data-bs-toggle="collapse" data-bs-target="#WesternGateway_img">Western Gateway</div>
        </div>
        <h3 class="fill-gray">
          Central Region <span class="miniText inline">Lakes, Hills, Forest</span>
        </h3>
        <div id="accordion4">
          <div id="Falkhorn_img" class="collapse" data-bs-parent="#accordion4">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Falkhorn_img" :src="require('../assets/Falkhorn.png')" />
          </div>
          <div id="Dragonsclutch_img" class="collapse" data-bs-parent="#accordion4">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Dragonsclutch_img" :src="require('../assets/Dragonsclutch.png')" />
          </div>
          <div id="Silverbridge_img" class="collapse" data-bs-parent="#accordion4">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Silverbridge_img" :src="require('../assets/Silverbridge.png')" />
          </div>
          <div id="Stormkeep_img" class="collapse" data-bs-parent="#accordion4">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Stormkeep_img" :src="require('../assets/Stormkeep.png')" />
          </div>
          <div id="Seaside_img" class="collapse" data-bs-parent="#accordion4">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Seaside_img" :src="require('../assets/Seaside.png')" />
          </div>
          <div id="Bronzeforge_img" class="collapse" data-bs-parent="#accordion4">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Bronzeforge_img" :src="require('../assets/Bronzeforge.png')" />
          </div>
        </div>
        <div class="setting-grid-container">
          <div class="button cursor gray" id="Falkhorn"         data-bs-parent="#accordion4" data-bs-toggle="collapse" data-bs-target="#Falkhorn_img">Falkhorn</div>
          <div class="button cursor gray" id="Dragonsclutch"    data-bs-parent="#accordion4" data-bs-toggle="collapse" data-bs-target="#Dragonsclutch_img">Dragonsclutch</div>
          <div class="button cursor gray" id="Silverbridge"     data-bs-parent="#accordion4" data-bs-toggle="collapse" data-bs-target="#Silverbridge_img">Silverbridge</div>
          <div class="button cursor gray" id="Stormkeep"        data-bs-parent="#accordion4" data-bs-toggle="collapse" data-bs-target="#Stormkeep_img">Stormkeep</div>
          <div class="button cursor gray" id="Seaside"          data-bs-parent="#accordion4" data-bs-toggle="collapse" data-bs-target="#Seaside_img">Seaside</div>
          <div class="button cursor gray" id="Bronzeforge"      data-bs-parent="#accordion4" data-bs-toggle="collapse" data-bs-target="#Bronzeforge_img">Bronzeforge</div>
        </div>
        <h3 class="fill-blue">
          Northern Region <span class="miniText inline">Tundra, Mountains</span>
        </h3>
        <div id="accordion5">
          <div id="Pinehaven_img" class="collapse" data-bs-parent="#accordion5">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Pinehaven_img" :src="require('../assets/Pinehaven.png')" />
          </div>
          <div id="Winterspell_img" class="collapse" data-bs-parent="#accordion5">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Winterspell_img" :src="require('../assets/Winterspell.png')" />
          </div>
          <div id="Everfrost_img" class="collapse" data-bs-parent="#accordion5">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Everfrost_img" :src="require('../assets/Everfrost.png')" />
          </div>
          <div id="Oakhaven_img" class="collapse" data-bs-parent="#accordion5">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Oakhaven_img" :src="require('../assets/Oakhaven.png')" />
          </div>
          <div id="Northpass_img" class="collapse" data-bs-parent="#accordion5">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Northpass_img" :src="require('../assets/Northpass.png')" />
          </div>
          <div id="CelestialHeights_img" class="collapse" data-bs-parent="#accordion5">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#CelestialHeights_img" :src="require('../assets/CelestialHeights.png')" />
          </div>
        </div>
        <div class="setting-grid-container">
          <div class="button cursor blue" id="Pinehaven"        data-bs-parent="#accordion5" data-bs-toggle="collapse" data-bs-target="#Pinehaven_img">Pinehaven</div>
          <div class="button cursor blue" id="Winterspell"      data-bs-parent="#accordion5" data-bs-toggle="collapse" data-bs-target="#Winterspell_img">Winterspell</div>
          <div class="button cursor blue" id="Everfrost"        data-bs-parent="#accordion5" data-bs-toggle="collapse" data-bs-target="#Everfrost_img">Everfrost</div>
          <div class="button cursor blue" id="Oakhaven"         data-bs-parent="#accordion5" data-bs-toggle="collapse" data-bs-target="#Oakhaven_img">Oakhaven</div>
          <div class="button cursor blue" id="Northpass"        data-bs-parent="#accordion5" data-bs-toggle="collapse" data-bs-target="#Northpass_img">Northpass</div>
          <div class="button cursor blue" id="CelestialHeights" data-bs-parent="#accordion5" data-bs-toggle="collapse" data-bs-target="#CelestialHeights_img">Celestial Heights</div>
        </div>
        <h3 class="fill-green">
          Eastern Region <span class="miniText inline">Boulders, Lakes, Forest</span>
        </h3>
        <div id="accordion6">
          <div id="EasternLocks_img" class="collapse" data-bs-parent="#accordion6">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#EasternLocks_img" :src="require('../assets/EasternLocks.png')" />
          </div>
          <div id="Boulderglen_img" class="collapse" data-bs-parent="#accordion6">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Boulderglen_img" :src="require('../assets/Boulderglen.png')" />
          </div>
          <div id="Helmstead_img" class="collapse" data-bs-parent="#accordion6">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Helmstead_img" :src="require('../assets/Helmstead.png')" />
          </div>
          <div id="Crescentport_img" class="collapse" data-bs-parent="#accordion6">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Crescentport_img" :src="require('../assets/Crescentport.png')" />
          </div>
          <div id="Moongarden_img" class="collapse" data-bs-parent="#accordion6">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Moongarden_img" :src="require('../assets/Moongarden.png')" />
          </div>
          <div id="Emberglades_img" class="collapse" data-bs-parent="#accordion6">
            <img class="cityImage centerImage cursor" data-bs-toggle="collapse" data-bs-target="#Emberglades_img" :src="require('../assets/Emberglades.png')" />
          </div>
        </div>
        <div class="setting-grid-container">
          <div class="button cursor green" id="EasternLocks"    data-bs-parent="#accordion6" data-bs-toggle="collapse" data-bs-target="#EasternLocks_img">Eastern Locks</div>
          <div class="button cursor green" id="Boulderglen"     data-bs-parent="#accordion6" data-bs-toggle="collapse" data-bs-target="#Boulderglen_img">Boulderglen</div>
          <div class="button cursor green" id="Helmstead"       data-bs-parent="#accordion6" data-bs-toggle="collapse" data-bs-target="#Helmstead_img">Helmstead</div>
          <div class="button cursor green" id="Crescentport"    data-bs-parent="#accordion6" data-bs-toggle="collapse" data-bs-target="#Crescentport_img">Crescentport</div>
          <div class="button cursor green" id="Moongarden"      data-bs-parent="#accordion6" data-bs-toggle="collapse" data-bs-target="#Moongarden_img">Moongarden</div>
          <div class="button cursor green" id="Emberglades"     data-bs-parent="#accordion6" data-bs-toggle="collapse" data-bs-target="#Emberglades_img">Emberglades</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Cities from './../components/Cities.vue'
  export default {
    components: {
      Cities
    },
    data: {
      Boulderglen: '../assets/Boulderglen.png',
      Bronzeforge: '../assets/Bronzeforge.png',
      CelestialHeights: '../assets/CelestialHeights.png',
      CloverSprings: '../assets/CloverSprings.png',
      Copperbrook: '../assets/Copperbrook.png',
      Crescentport: '../assets/Crescentport.png',
      Dragonsclutch: '../assets/Dragonsclutch.png',
      EasternLocks: '../assets/EasternLocks.png',
      Everfrost: '../assets/Everfrost.png',
      Falkhorn: '../assets/Falkhorn.png',
      Firedeep: '../assets/Firedeep.png',
      Frostport: '../assets/Frostport.png',
      Harbordock: '../assets/Harbordock.png',
      Helmstead: '../assets/Helmstead.png',
      Hillfar: '../assets/Hillfar.png',
      MapleFalls: '../assets/MapleFalls.png',
      Moongarden: '../assets/Moongarden.png',
      Mossgrove: '../assets/Mossgrove.png',
      Northpass: '../assets/Northpass.png',
      Oakhaven: '../assets/Oakhaven.png',
      Pinehaven: '../assets/Pinehaven.png',
      Seaside: '../assets/Seaside.png',
      Silverbridge: '../assets/Silverbridge.png',
      SouthernChannels: '../assets/SouthernChannels.png',
      Stormkeep: '../assets/Stormkeep.png',
      Thornbeak: '../assets/Thornbeak.png',
      Valor: '../assets/Valor.png',
      WesternGates: '../assets/WesternGates.png',
      Windfell: '../assets/Windfell.png',
      Winterspell: '../assets/Winterspell.png',
    },
    methods: {
      // https://www.codegrepper.com/code-examples/whatever/vue+js+change+image+src
      // https://forum.vuejs.org/t/change-image-src-with-on-click/94810/8
      // https://copyprogramming.com/howto/vue-js-change-image-src-with-a-click
      // https://tutorialsplane.com/runtest/try.php?trycode=vue-js-change-image-src&post_code=code9&full=&w=1
      thornbeak() {	
        if (this.cityImage.src != '../assets/Thornbeak.png') {
          this.cityImage.src='../assets/Thornbeak.png';
        }
      },
      toggleimage() {
        if (this.src != '../assets/Falkhorn.png') {
          this.src='../assets/Falkhorn.png';
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
::-webkit-scrollbar-thumb {
  background: #4484b8;
  width: 10px;
}
.inline {
  display: inline;
}
.fill-red {
  border-radius: 10px;
  background-color: #c42f24;
  padding: 10px;
  color: black;
  font-weight: bolder;
}
.red {
  border-radius: 10px;
  border: solid 2px #c42f24;
  padding: 10px;
  font-weight: bolder;
}
.fill-yellow {
  border-radius: 10px;
  background-color: #c7ae20;
  padding: 10px;
  color: black;
  font-weight: bolder;
}
.yellow {
  border-radius: 10px;
  border: solid 2px #c7ae20;
  padding: 10px;
  font-weight: bolder;
}
.fill-gray {
  border-radius: 10px;
  background-color: #414141;
  padding: 10px;
  font-weight: bolder;
}
.gray {
  border-radius: 10px;
  border: solid 2px #414141;
  padding: 10px;
  font-weight: bolder;
}
.fill-blue {
  border-radius: 10px;
  background-color: #365ba1;
  padding: 10px;
  color: black;
  font-weight: bolder;
}
.fill {
  background-color: #4484b8;
  // padding: 10px;
  color: black;
  font-weight: bolder;
}
.blue {
  border-radius: 10px;
  border: solid 2px #365ba1;
  padding: 10px;
  font-weight: bolder;
}
.fill-green {
  border-radius: 10px;
  background-color: #71ad40;
  padding: 10px;
  color: black;
  font-weight: bolder;
}
.green {
  border-radius: 10px;
  border: solid 2px #71ad40;
  padding: 10px;
  font-weight: bolder;
}
.blue-fill {
  background-color: #4484b8;
  padding: 10px;
  color: black;
  font-weight: bolder;
}
.genericButton {
  border: 2px solid white;
  background-color: #080808;
  float: none;
  border-radius: 15px;
  color: white;
  padding-top: 15px;
  padding-bottom: 10px;
  text-align: center;
  width: 100%;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin-bottom: 15px;
}
/* *********************************** */
// City images
.valor  { 
  background-image: url('../assets/Valor.png');  
  width: 100%;
  height: auto;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: 20px;
}
#factionsTable {
  tr {
    td {
      padding-bottom: 20px;
      padding-top: 20px;
    }
  }
}
#raceT, #languageT {
  display: table;
  // table-layout: fixed;
  width: 100%;
  // overflow-wrap: break-word;
}
#raceT {
  td:first-child {
    min-width: 85px;
  }
}
#rTable {
  tr {
    td {
      padding-bottom: 7px;
    }
  }
}
#languageT {
    td {
      padding-bottom: 2px;
      padding-top: 2px;
    }
  }
@media screen and (min-width: 768px) {
  #languageT {
    width: 50%;
    margin-right: auto;
    margin-left: auto;
    td {
      padding-bottom: 2px;
      padding-top: 2px;
      padding-right: 20px !important;
      padding-left: 40% !important;
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 900px) {
  #languageT {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }
}
@media screen and (max-width: 768px) {
  #languageT {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    td {
      padding-bottom: 2px;
      padding-top: 2px;
      padding-right: 20px !important;
      padding-left: 42% !important;
    }
  }
}
@media screen and (min-width: 900px) {
  .grid-container {
    // grid-template-areas: 'Introduction EnemyBehavior Loot'
    //                      'Terrain Weather Magic';
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  }
  .setting-grid-container {
    grid-template-areas: '';
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  }
  .grid-container {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .languageT {
    width: 50%;
  }
}
</style>